import React from "react";

const columns = (self) => {
  let initialValue = self.initialValue || {}
  let {corpInfoId, personId, userName, fullName, idCard, state, userId, openId} = initialValue
  return [
    {
      name: "corpInfoId",
      formItem: {
        type: "hidden",
        initialValue: corpInfoId
      }
    },
    {
      name: "personId",
      formItem: {
        type: "hidden",
        initialValue: personId
      }
    },
    {
      title: "账号",
      name: "userName",
      dataIndex: "userName",
      formItem: {
        disabled: true,
        initialValue: userName,
      },
    },
    {
      title: "姓名",
      name: "fullName",
      dataIndex: "fullName",
      formItem: {
        disabled: true,
        initialValue: fullName,
      },
    },
    {
      title: "身份证号",
      name: "idCard",
      dataIndex: "idCard",
      formItem: {
        disabled: true,
        initialValue: idCard,
      },
    },
    {
      title: "状态",
      name: "state",
      dataIndex: "state",
      dict: [
        {code: 1, codeName: "激活"},
        {code: 0, codeName: "禁用"}
      ],
      formItem: {
        type: 'select',
        disabled: true,
        initialValue: state,
      },
    },
    {
      title: "企业内账号",
      name: "userId",
      dataIndex: "userId",
      formItem: {
        initialValue: userId,
        rules: [
          { required: true, message: '请输入企业内账号' },
        ],
      },
    },
    {
      title: "openId",
      name: "openId",
      dataIndex: "openId",
      formItem: {
        initialValue: openId,
      },
    },
  ]
}

export {columns}
